import React from 'react';
import {
  Tab,
  Row,
  Col,
  Nav,
  NavItem,
} from 'react-bootstrap';

import TimesheetListEnhanced from './TimesheetListEnhanced';

import './TabbedTimesheetApprovals.css';

const TabbedTimesheetApprovals = (props) => {
  return (
    <div>
      <Tab.Container defaultActiveKey={1} id="statusTabs">
        <Row className="clearfix">
          <Col sm={12}>
            <Nav bsStyle="tabs">
              <NavItem eventKey={1}>
                <label>Unapproved
                </label>
              </NavItem>
              <NavItem eventKey={2}>
                <label>
                  Approved
                </label>
              </NavItem>
            </Nav>
          </Col>
          <Col sm={12} className="tabbedTimesheetApprovals-scrollbar">
            <Tab.Content animation={false}>
              <Tab.Pane eventKey={1}>
                <TimesheetListEnhanced approvalState="unapproved" />
              </Tab.Pane>
              <Tab.Pane eventKey={2}>
                <TimesheetListEnhanced approvalState="approved" />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default TabbedTimesheetApprovals;
